import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import React from "react";


export default function FlexTable(props) {
    const columns = props.columns
    const rows = props.rows
    const borderStyle = "1px solid #e0e0e0"
    const cellPadding = "2px 8px 2px 8px"

    const headerCellStyle = {
        border: borderStyle,
        padding: cellPadding,
        fontWeight: "700"
    }

    const bodyCellStyle = {
        border: borderStyle,
        padding: cellPadding,
    }

    return (
            <TableContainer>
                <Table aria-label="simple table" size="small" sx={{ width: "max-content" }}>
                    <TableHead>
                        <TableRow>
                            {columns.map((column, index) => (
                                <TableCell key={index} sx={ headerCellStyle }>{column}</TableCell>
                            ))}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows.map((row, i) => (
                            <TableRow key={i}>
                                {columns.map((column, j) => (
                                    <TableCell key={`${i}-${j}`} sx={ bodyCellStyle }>{row[column]}</TableCell>
                                ))}
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
    )
}